import { render, staticRenderFns } from "./style-guide-view.vue?vue&type=template&id=37e03be2&scoped=true&lang=pug"
import script from "./style-guide-view.js?vue&type=script&lang=js&external"
export * from "./style-guide-view.js?vue&type=script&lang=js&external"
import style0 from "./style-guide-view.vue?vue&type=style&index=0&id=37e03be2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e03be2",
  null
  
)

export default component.exports